var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.25C16.8995 19.25 19.25 16.8995 19.25 14C19.25 11.1005 16.8995 8.75 14 8.75C11.1005 8.75 8.75 11.1005 8.75 14C8.75 16.8995 11.1005 19.25 14 19.25Z",
    stroke: "#BDBDBD",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72042 10.0187C5.9173 9.6031 6.14698 9.20935 6.40948 8.82654L6.36573 5.98279C6.36573 5.72029 6.47511 5.46872 6.68292 5.29372C7.70011 4.4406 8.85948 3.75154 10.1392 3.29216C10.3907 3.20466 10.6642 3.22654 10.8829 3.36872L13.322 4.83435C13.7814 4.80154 14.2407 4.80154 14.7001 4.83435L17.1392 3.36872C17.3689 3.23747 17.6423 3.20466 17.8939 3.29216C19.1407 3.7406 20.311 4.40779 21.3501 5.28279C21.547 5.44685 21.6673 5.70935 21.6564 5.97185L21.6126 8.8156C21.8751 9.19841 22.1048 9.59216 22.3017 10.0078L24.7845 11.3859C25.0142 11.5172 25.1782 11.7359 25.222 11.9984C25.4517 13.3 25.4626 14.6562 25.222 15.9797C25.1782 16.2422 25.0142 16.4609 24.7845 16.5922L22.3017 17.9703C22.1048 18.3859 21.8751 18.7797 21.6126 19.1625L21.6564 22.0062C21.6564 22.2687 21.547 22.5203 21.3392 22.6953C20.322 23.5484 19.1626 24.2375 17.8829 24.6968C17.6314 24.7843 17.3579 24.7625 17.1392 24.6203L14.7001 23.1547C14.2407 23.1875 13.7814 23.1875 13.322 23.1547L10.8829 24.6203C10.6532 24.7515 10.3798 24.7843 10.1282 24.6968C8.88136 24.2484 7.71105 23.5812 6.67198 22.7062C6.47511 22.5422 6.3548 22.2797 6.36573 22.0172L6.40948 19.1734C6.14698 18.7906 5.9173 18.3968 5.72042 17.9812L3.23761 16.6031C3.00792 16.4718 2.84386 16.2531 2.80011 15.9906C2.57042 14.689 2.55948 13.3328 2.80011 12.0093C2.84386 11.7468 3.00792 11.5281 3.23761 11.3968L5.72042 10.0187Z",
    stroke: "#BDBDBD",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/SettingsIcon.e041add24176d6b7ba89cae8f6d2350e.svg";
export { ForwardRef as ReactComponent };